import Immutable from 'immutable';

// constants
import { TOOLTIP_ADD, TOOLTIP_EDIT, TOOLTIP_HIDE, TOOLTIP_REMOVE, TOOLTIP_SHOW } from '../constants/tooltipTypes';

const add = function(state, action) {
  const { payload } = action;
  const data        = state.get('data') || Immutable.Map();

  let newState = state;

  if (payload.id) {
    newState = state.set('data', data.set(payload.id, Immutable.fromJS({ active: false })));
  }

  return newState;
};

const hide = function(state, action) {
  const { payload } = action;
  const data        = state.get('data') || Immutable.Map();

  return state.set('data', data.set(payload.id, Immutable.fromJS({ active: false })));
};

const remove = function(state, action) {
  const { payload } = action;
  const data        = state.get('data') || Immutable.Map();

  return state.set('data', data.delete(payload.id));
};

const show = function(state, action) {
  const { payload } = action;
  const data        = state.get('data') || Immutable.Map();

  return state.set('data', data.set(payload.id, Immutable.fromJS({ active: true })));
};

const edit = function(state, action) {
  const { payload } = action;
  const data        = state.get('data') || Immutable.Map();

  return state.set('data', data.set(payload.id, Immutable.fromJS({ active: true, status: payload.status })));
};

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case TOOLTIP_ADD:     return add(state, action);
    case TOOLTIP_HIDE:    return hide(state, action);
    case TOOLTIP_REMOVE:  return remove(state, action);
    case TOOLTIP_SHOW:    return show(state, action);
    case TOOLTIP_EDIT:    return edit(state, action);
    default:              return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/tooltip.js